<template>
    <div class="component">
      <div class="component-title" style="margin-bottom: 8px;">当天订单取消规则</div>
      <div class="fee-deduction-describe">根据订单不同的运输状态所产生的实际运输成本不同，我们将对取消的订单收取部分费用</div>
      <table style="margin-bottom: 4px;">
        <tbody>
          <tr style="height: 32px;background: #F8F8F8;">
            <td width="50%" style="font-size: 16px;font-weight: 400;">运输状态</td>
            <td width="50%" style="font-size: 16px;font-weight: 400;">取消成本</td>
          </tr>
          <tr style="height: 44px;">
            <td width="50%" style="font-size: 12px;font-weight: 400;">到达装货地前</td>
            <td width="50%" style="font-size: 12px;color: #EC892E;">{{carAttributeFeeConfig.fastOrderCancelTransportOrderRule&&carAttributeFeeConfig.fastOrderCancelTransportOrderRule.driverTakeOrderChargingRule?carAttributeFeeConfig.fastOrderCancelTransportOrderRule.driverTakeOrderChargingRule:0}}元</td>
          </tr>
          <tr style="height: 44px;">
            <td width="50%" style="font-size: 12px;font-weight: 400;">到达装货地后</td>
            <td width="50%" style="font-size: 12px;color: #EC892E;">{{carAttributeFeeConfig.fastOrderCancelTransportOrderRule&&carAttributeFeeConfig.fastOrderCancelTransportOrderRule.driverArrivalOfLoadingChargingRule?carAttributeFeeConfig.fastOrderCancelTransportOrderRule.driverArrivalOfLoadingChargingRule:0}}元</td>
          </tr>
        </tbody>
      </table>
    </div>
  </template>
  
  <script>
  export default {
    name:"IntradayCancel",
    props:["carAttributeFeeConfig"],
  }
  </script>
  
  <style scoped lang="scss">
  .fee-deduction-describe{
    font-weight: 400;
    font-size: 12px;
    color: #85807B;
    margin-bottom: 8px;
  }
   table,
    th,
    td {
      border: 1px solid #C9C2BB;
      color: #3D3833;
      font-weight: 400;
    }
  
    table {
      width: 100%;
      margin: 0 auto;
      display: table;
      border-spacing: 0;
      border-radius: 4px;
      overflow: hidden;
    }
    th,
    td {
      border-top-width: 0;
      border-left-width: 0;
      text-align: center;
    }
  
    th:last-child,
    td:last-child {
      border-right-width: 0;
    }
  
    tr:last-child td {
      border-bottom-width: 0;
    }
  </style>